module.exports = __webpack_public_path__ + "img/svg/paypal_full.59f699b285cfcc915e3870bad7b40c77.svg";